import { signupPhrases } from '../lib/signupOffer';
import { Button } from './Button';

/**
 * Human onboarding action shared by prerendered marketing and catalog pages.
 *
 * A plain link to `/sign-up`. It used to open Clerk's modal behind a `mounted`
 * gate, which pulled Clerk into every marketing bundle and forced the server and
 * first client render to disagree about what the button was. The signup page now
 * owns identity: a signed-in visitor who lands there is sent to the dashboard.
 */
export const WalletCta = ({
  className,
  label,
  onClick,
}: {
  className?: string;
  /** Overridden only by the landing hero, which carries the offer on the button. */
  label?: string;
  /** Analytics hook for placements that need to attribute the click to context. */
  onClick?: () => void;
}) => (
  <Button as="a" to="/sign-up" variant="primary" className={className} onClick={onClick}>
    {label ?? signupPhrases().HUMAN_SIGNUP_CTA}
  </Button>
);
